import { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from "@mui/material";

interface Props {
	open: boolean;
	eventName?: string;
	rewardPreview?: string;
	loading?: boolean;
	onClose: () => void;
	onConfirm: (reviewNotes?: string) => void;
}

export const ApproveDialog = ({
	open,
	eventName,
	rewardPreview,
	loading,
	onClose,
	onConfirm,
}: Props) => {
	const [notes, setNotes] = useState("");

	const handleConfirm = (): void => {
		onConfirm(notes.trim() || undefined);
		setNotes("");
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>Approve submission</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>
					Approve the submission for{" "}
					<strong>{eventName ?? "this event"}</strong>?
					{rewardPreview && ` ${rewardPreview}`}
				</DialogContentText>
				<TextField
					label="Review notes (optional)"
					fullWidth
					multiline
					rows={3}
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					inputProps={{ maxLength: 1000 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={loading}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="success"
					onClick={handleConfirm}
					disabled={loading}
				>
					Confirm Approval
				</Button>
			</DialogActions>
		</Dialog>
	);
};
